export default "__VITE_ASSET__DSvY4u5V__"